import React from "react";
import { Phone, MessageCircle, Mail, MapPin, Clock } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const PHONE = "9467458749";
const WHATSAPP = "https://wa.me/919467458749";
const EMAIL = "sales@thepataudi.com";

export default function Contact() {
  return (
    <div className="min-h-screen flex flex-col bg-background" data-testid="contact-page">
      <Header />
      <main className="flex-1">
        <section className="bg-primary text-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 py-14 md:py-16">
            <p className="text-accent text-sm font-semibold tracking-wider uppercase mb-3">Contact Us</p>
            <h1 className="font-display text-4xl md:text-5xl font-bold leading-tight">We&apos;re here to help.</h1>
            <p className="text-white/80 mt-4 max-w-2xl text-base md:text-lg">
              Have a question about a listing or your account? Reach us directly — we usually reply within a few hours.
            </p>
          </div>
        </section>

        <section className="max-w-5xl mx-auto px-4 sm:px-6 py-12 md:py-16">
          <div className="grid md:grid-cols-3 gap-5">
            <a
              href={`tel:${PHONE}`}
              data-testid="contact-call-card"
              className="group bg-card rounded-md border border-border p-6 hover:border-primary/40 hover:shadow-sm transition-all"
            >
              <div className="h-11 w-11 rounded-md bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/15 transition-colors">
                <Phone className="h-5 w-5 text-primary" />
              </div>
              <h3 className="font-display font-semibold text-lg text-ink mb-1">Call us</h3>
              <p className="text-sm text-ink/60 mb-3">Speak to our team directly.</p>
              <p className="text-base font-medium text-primary">+91 {PHONE}</p>
            </a>

            <a
              href={WHATSAPP}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-card"
              className="group bg-card rounded-md border border-border p-6 hover:border-[#25D366]/50 hover:shadow-sm transition-all"
            >
              <div className="h-11 w-11 rounded-md bg-[#25D366]/10 flex items-center justify-center mb-4 group-hover:bg-[#25D366]/20 transition-colors">
                <MessageCircle className="h-5 w-5 text-[#25D366]" />
              </div>
              <h3 className="font-display font-semibold text-lg text-ink mb-1">WhatsApp us</h3>
              <p className="text-sm text-ink/60 mb-3">Quick chat, faster replies.</p>
              <p className="text-base font-medium text-[#1ebe5d]">Open WhatsApp Chat →</p>
            </a>

            <a
              href={`mailto:${EMAIL}`}
              data-testid="contact-email-card"
              className="group bg-card rounded-md border border-border p-6 hover:border-accent/50 hover:shadow-sm transition-all"
            >
              <div className="h-11 w-11 rounded-md bg-accent/10 flex items-center justify-center mb-4 group-hover:bg-accent/15 transition-colors">
                <Mail className="h-5 w-5 text-accent" />
              </div>
              <h3 className="font-display font-semibold text-lg text-ink mb-1">Email us</h3>
              <p className="text-sm text-ink/60 mb-3">For detailed queries.</p>
              <p className="text-base font-medium text-accent break-all">{EMAIL}</p>
            </a>
          </div>

          <div className="mt-10 grid md:grid-cols-2 gap-5">
            <div className="bg-card rounded-md border border-border p-6">
              <div className="flex items-center gap-2 mb-2">
                <MapPin className="h-5 w-5 text-primary" />
                <h3 className="font-display font-semibold text-lg text-ink">Service area</h3>
              </div>
              <p className="text-sm text-ink/70">
                We currently serve Gurugram, Pataudi, Manesar, Farrukhnagar and nearby areas. New regions are being added — stay tuned.
              </p>
            </div>
            <div className="bg-card rounded-md border border-border p-6">
              <div className="flex items-center gap-2 mb-2">
                <Clock className="h-5 w-5 text-primary" />
                <h3 className="font-display font-semibold text-lg text-ink">Support hours</h3>
              </div>
              <p className="text-sm text-ink/70">
                Monday to Saturday, 9:00 AM – 8:00 PM IST. WhatsApp messages outside these hours will be answered the next working day.
              </p>
            </div>
          </div>

          <div className="mt-10 rounded-md bg-muted/40 border border-border p-6 md:p-8 text-center">
            <h3 className="font-display font-bold text-xl md:text-2xl text-ink mb-2">Prefer to talk right now?</h3>
            <p className="text-ink/70 mb-5">Tap below — your phone will do the rest.</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href={`tel:${PHONE}`}
                data-testid="contact-call-now-btn"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-sm bg-primary hover:bg-primary/90 text-white font-medium text-sm transition-colors"
              >
                <Phone className="h-4 w-4" /> Call Now
              </a>
              <a
                href={WHATSAPP}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-btn"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-sm bg-[#25D366] hover:bg-[#1ebe5d] text-white font-medium text-sm transition-colors"
              >
                <MessageCircle className="h-4 w-4" /> Chat on WhatsApp
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
